import { render, staticRenderFns } from "./PartsSuppliers.vue?vue&type=template&id=32ffb233&scoped=true"
import script from "./PartsSuppliers.vue?vue&type=script&lang=js"
export * from "./PartsSuppliers.vue?vue&type=script&lang=js"
import style0 from "./PartsSuppliers.vue?vue&type=style&index=0&id=32ffb233&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ffb233",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ffb233')) {
      api.createRecord('32ffb233', component.options)
    } else {
      api.reload('32ffb233', component.options)
    }
    module.hot.accept("./PartsSuppliers.vue?vue&type=template&id=32ffb233&scoped=true", function () {
      api.rerender('32ffb233', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/PriceParts/PartsSuppliers.vue"
export default component.exports